/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { EditOutlined } from '@ant-design/icons';
import { FocusEventHandler, useState } from 'react';

import { EditableNodeNameForm } from '@/components/Node/EditableNodeNameForm';
import { Space } from '@/primitives/Space';
import { Text } from '@/primitives/Text';
import { tokens } from '@/theme';

export type EditableNodeNameProps = {
  name: string;
  onNameChange: (newNodeName: string) => void;
};

export function EditableNodeName({ name, onNameChange }: EditableNodeNameProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [nodeName, setNodeName] = useState(name);

  const onNameBlur: FocusEventHandler<HTMLInputElement> = (event) => {
    const newNodeName = event.target.value.trim();
    setIsEditing(false);
    onNameChange(newNodeName);
    setNodeName(newNodeName);
  };

  return (
    <>
      {!isEditing && (
        <Space>
          <Text data-testid="node-name" size="xl">
            {nodeName}
          </Text>
          <EditOutlined
            onClick={() => setIsEditing(true)}
            data-testid="edit-node-name"
            style={{
              fontSize: '1.25rem',
              color: tokens.color.components.link.linkDefault,
              display: 'flex',
              justifyItems: 'center',
              alignItems: 'center',
              height: '44px',
              width: '44px',
            }}
          />
        </Space>
      )}
      {isEditing && <EditableNodeNameForm name={name} onNameBlur={onNameBlur} setNodeName={setNodeName} />}
    </>
  );
}
